import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Leaf, Zap, Droplet, Sparkles } from 'lucide-react';
export function SolutionSection() {
  const benefits = [{
    icon: <Droplet className="w-6 h-6 text-sage-green" data-id="element-226" />,
    title: 'Adiós al "Bloating"',
    desc: 'Desinflama tu abdomen en 48 horas con el protocolo SOS.'
  }, {
    icon: <Zap className="w-6 h-6 text-sage-green" data-id="element-227" />,
    title: 'Energía Estable',
    desc: 'Despídete de la niebla mental de la tarde.'
  }, {
    icon: <Leaf className="w-6 h-6 text-sage-green" data-id="element-228" />,
    title: 'Pérdida de Grasa Inteligente',
    desc: 'Usa tu fase folicular para quemar más sin pasar hambre.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-sage-green" data-id="element-229" />,
    title: 'Piel Radiante',
    desc: 'Limpia tu acné hormonal desde la raíz (tu hígado).'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-12 md:py-32 bg-cream-white" data-id="element-230">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-232">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1 relative" data-id="element-233">
            <div className="absolute inset-0 bg-sage-green/10 rounded-3xl transform -rotate-3 scale-105" data-id="element-234"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iag9TmkkPqHt9rfpmjUPTT/mk-2.png" alt="El Código Hormonal 28D Fases" className="relative rounded-3xl shadow-xl w-full object-cover" data-id="element-235" />
          </motion.div>

          <div className="order-1 lg:order-2" data-id="element-236">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-237">
              <h2 className="text-sm font-bold tracking-widest text-sage-green uppercase mb-3" data-id="element-238">
                Presentando la Solución
              </h2>
              <h3 className="text-3xl md:text-4xl font-heading font-bold text-deep-charcoal mb-6" data-id="element-239">
                "EL CÓDIGO HORMONAL 28D"
              </h3>
              <p className="text-base md:text-lg text-deep-charcoal/80 mb-6 md:mb-10 leading-relaxed" data-id="element-240">
                He creado el sistema definitivo de Bio-Hacking Femenino. Una
                hoja de ruta paso a paso para que sepas exactamente QUÉ comer y
                CÓMO entrenar según el día de tu ciclo en el que te encuentres.
              </p>
            </motion.div>

            <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="space-y-4 md:space-y-6" data-id="element-241">
              <h4 className="text-xl font-bold text-deep-charcoal mb-6" data-id="element-242">
                Lo que vas a lograr:
              </h4>

              {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4" data-id="element-243">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-sage-green/20 flex items-center justify-center mt-1" data-id="element-244">
                    {benefit.icon}
                  </div>
                  <div data-id="element-245">
                    <h5 className="text-lg font-bold text-deep-charcoal" data-id="element-246">
                      {benefit.title}
                    </h5>
                    <p className="text-deep-charcoal/70 mt-1" data-id="element-247">{benefit.desc}</p>
                  </div>
                </motion.div>)}
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}